import angular from "angular";
import Vue from "vue";
import "ngVue";

import Order from "./Order.vue";

export default angular.module("directives.order", []).directive("dcOrder", [
  "createVueComponent",
  function (createVueComponent) {
    return createVueComponent(Vue.component("DcOrder", Order));
  },
]);
